import {
  CardsGatewayIssuingModalAction,
  INITIALIZE_DATA,
  InitializeData,
  LoadingState,
  RESET,
  SET_LOADING,
  SET_SERVER_ERROR
} from '@Actions/cardsGatewayIssuingModalActions';

import { IParentCardOption } from '@ClientServices/api/cardIssuing';
import { ICompanyCategoryModel, IExpenseTagBucketModel } from '@Shared/models';

interface ICardsGatewayIssuingModalState {
  // General
  loading: LoadingState;
  serverError?: string;
  // Options
  parentCardOptions: IParentCardOption[];
  parentCardsById: Record<string, IParentCardOption>;
  categoryOptions: ICompanyCategoryModel[];
  expenseTagsBucketsForUser: IExpenseTagBucketModel[];
  // Original item
  issuingDetailsOriginalValues: any;
}

export const defaultState: ICardsGatewayIssuingModalState = {
  loading: 'body',
  serverError: null,
  parentCardOptions: [],
  parentCardsById: {},
  categoryOptions: [],
  expenseTagsBucketsForUser: [],
  issuingDetailsOriginalValues: null
};

const handleInitializeData = (state: ICardsGatewayIssuingModalState = defaultState, action: InitializeData) => {
  let parentCardOptions: IParentCardOption[] = state.parentCardOptions;
  let parentCardsById = state.parentCardsById;
  if (action.parentCardOptions) {
    parentCardOptions = action.parentCardOptions.map((card) => ({
      ...card,
      displayName: card.name ? `${card.name} ${card.last4}` : card.last4
    }));

    parentCardsById = parentCardOptions.reduce((accumulator: any, current: IParentCardOption) => {
      accumulator[current.id] = current;
      return accumulator;
    }, {});
  }

  return {
    ...state,
    loading: false,
    parentCardOptions,
    parentCardsById,
    issuingDetailsOriginalValues: action.issuingDetailsOriginalValues
  };
};

export function cardsGatewayIssuingModalReducer(
  state: ICardsGatewayIssuingModalState = defaultState,
  action: CardsGatewayIssuingModalAction
) {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: action.loading };
    case INITIALIZE_DATA:
      return handleInitializeData(state, action);
    case SET_SERVER_ERROR:
      return { ...state, serverError: action.message };
    case RESET:
      return { ...defaultState };
    default:
      return state;
  }
}
